import { render, staticRenderFns } from "./CustomerChat.vue?vue&type=template&id=7e2ba074&scoped=true&"
import script from "./CustomerChat.vue?vue&type=script&lang=js&"
export * from "./CustomerChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2ba074",
  null
  
)

export default component.exports